import React from "react";

function Order() {
  return (
    <div>
      <section class="text-gray-400 bg-gray-900 body-font">
        <div class="container px-5 py-24 mx-auto flex flex-wrap">
          <h2 class="sm:text-3xl text-2xl text-white font-medium title-font mb-2 md:w-2/5">
            Order us online with{"  "}
            <span class="sm:text-3xl text-2xl text-green-500 font-medium title-font mb-2 md:w-2/5">
              Whatsapp
            </span>
          </h2>
          <div class="md:w-3/5 md:pl-6">
            <p class="leading-relaxed text-grey">
              Send us the photo of your grocery list. Then we will verify the
              order and place it. After that whenever you can come and takeway.
            </p>
            <div class="flex md:mt-4 mt-6">
              <a
                class="inline-flex text-white bg-green-500 border-0 py-1 px-4 focus:outline-none hover:bg-purple-600 rounded"
                href="https://wa.me/919386150762"
              >
                Order
                <span>
                  <img src="https://img.icons8.com/color/25/000000/whatsapp.png" />
                </span>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Order;
